
export default function LogoTitle() {
    return (
        <img src="/icon/logo.svg" alt="Logo" className='w-24' />
    )
}